
import {Component} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {RestApiService} from '../shared/restApiServices/restapi.service';
import { Router ,ActivatedRoute } from '@angular/router';
import { MatDialogRef } from "@angular/material";
import {isUndefined} from "util";

@Component({
  selector: 'log-in',
  templateUrl: './log-in.component.html',
  styleUrls: ['log-in.component.css']
})

export class LogInDialogComponent {

  userName: string;
  password:string;
  loginFail:boolean;
  loginFailMsg:string;
  successMsg: string;
  color = 'green';
  mode = 'indeterminate';
  isShowLoader = false;
  userNameEmpty;
  passwordEmpty;

  constructor(public dialogRef: MatDialogRef<LogInDialogComponent>, private http: HttpClient,  private restApiService:RestApiService,private router: Router , private route: ActivatedRoute) {
    this.loginFail = false;
    this.successMsg = '';
    this.loginFailMsg = "";
    if( this.route.queryParams['_value']['email'])
    {
      this.userName = this.route.queryParams['_value']['email'];
      this.successMsg = 'Password successfully set.';
    }
  }

  loginRequest() {

    if(this.userName==null || isUndefined(this.userName) || this.userName=="")
    {
      this.userNameEmpty = "on-error";
      this.passwordEmpty = "";
      return;
    }
    else if(this.password==null || isUndefined(this.password) || this.password=="")
    {
      this.userNameEmpty = "";
      this.passwordEmpty = "on-error";
        return;
    }
    else {
      this.userNameEmpty = "";
      this.passwordEmpty = "";
      this.isShowLoader=true;
      this.restApiService.surveyorLogInRequestService(this.userName, this.password).subscribe(
        result => {
          if(result.success)
          {
            this.isShowLoader = false;
              
            if (result.tokens.accessToken)
            {
              localStorage.setItem("surveyorToken", JSON.stringify(result.tokens));
            }
            this.dialogRef.close(result)
          }
          else {
            //login failed
            this.isShowLoader = false;
            this.loginFailMsg = result.value.message;
            this.loginFail = true;
            console.log(this.loginFailMsg);
          }

        })
    }
  };

}



// WEBPACK FOOTER //
// ./src/app/logInComponent/log-in.component.ts